import { render, staticRenderFns } from "./merchant-management.vue?vue&type=template&id=0f9bc358&scoped=true"
import script from "./merchant-management.vue?vue&type=script&lang=js"
export * from "./merchant-management.vue?vue&type=script&lang=js"
import style0 from "./merchant-management.vue?vue&type=style&index=0&id=0f9bc358&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9bc358",
  null
  
)

export default component.exports